export default {
    errorSoliCupo: false,
    msgErrorSoliCupo: '',
    loadingSoliCupo: false,
}